<style>
    .c-input-quantity-content {
        width: 150px;
    }

    .c-input-quantity{
        width: 45px!important;
        flex:none!important;
        border-radius:0px;
        text-align: center;
        border:1px solid #ddd;
    }

    .c-input-quantity-mp{
        width: 28px!important;
        height: 28px!important;
    }
</style>

<template>
    <div>
        <b-form-group
                class="c-text"
                :description="description"
                :label="label"
                :label-for="id"
                :label-cols="labelCols"
                :aria-describedby="id + '_InvalidFeedback'">
            <label v-if="dataReadOnly == true">{{dataValue}}</label>
            <b-input-group v-if="dataReadOnly == false" class="input-group-sm c-input-quantity-content">
                <b-input-group-prepend
                        class="c-input-quantity-mp"
                        @click="minus">
                    <b-input-group-text>
                        <i class="fa fa-minus"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                        class="c-input-quantity"
                        type="text"
                        :id="id"
                        v-model="dataValue"></b-form-input>
                <b-input-group-append
                        class="c-input-quantity-mp"
                        @click="plus">
                    <b-input-group-text>
                        <i class="fa fa-plus"></i>
                    </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append
                        v-if="dataDisplayValid"
                        @click="onValidClick">
                    <b-input-group-text :class="{ 'badge-success': dataDisplayValid }" class="badge">
                        <i class="fa fa-check"></i>
                    </b-input-group-text>
                </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
                {{invalidFeedbackMessage}}
            </b-form-invalid-feedback>
        </b-form-group>
    </div>
</template>

<script>
  export default {
      name: 'InputQuantity',
      props: {
          displayOnChangeValid: {
              type: Boolean,
              default: false
          },
          displayValid: {
              type: Boolean,
              default: false
          },
          id: {
              type: String,
              default: ''
          },
          value: {
              type: String | Number,
              default: '0'
          },
          label: {
              type: String,
              default: ''
          },
          max: {
              type: Number | String,
              default: 999
          },
          min: {
              type: Number | String,
              default: 0
          },
          step: {
              type: Number | String,
              default: 1
          },
          required: {
              type: Boolean,
              default: false
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              if (this.dataDisplayOnChangeValid) {
                  if (this.dataOldValue !== this.dataValue) {
                      this.dataDisplayValid = true
                  }
              }
              this.$emit('input', val)
              this.$emit('change', this.dataValue)
              this.dataOldValue = this.dataValue
          }
      },
      mounted() {
          this.dataReadOnly = this.readOnly
          this.dataValue = this.value
          this.dataDisplayOnChangeValid = this.displayOnChangeValid
          this.dataDisplayValid = this.displayValid
      },
      data: () => {
          return {
              dataValue: '0',
              dataOldValue: '0',
              dataDisplayOnChangeValid: false,
              dataDisplayValid: false,
              dataReadOnly: false
          }
      },
      methods: {
          reset() {
              if (isNaN(this.dataValue)) {
                  this.dataValue = '0'
              }
          },
          minus() {
              this.reset()
              this.step = parseInt(this.step)
              if ((parseInt(this.dataValue) - this.step) >= parseInt(this.min)) {
                  this.dataValue = (parseInt(this.dataValue) - this.step).toString()
              }
              this.$emit('onMinus', this.dataValue, this.step)
          },
          plus() {
              this.reset()
              this.step = parseInt(this.step)
              if ((parseInt(this.dataValue) + this.step) <= parseInt(this.max) || parseInt(this.max) === 0) {
                  this.dataValue = (parseInt(this.dataValue) + this.step).toString()
              }
              this.$emit('onPlus', this.dataValue, this.step)
          },
          onValidClick() {
              this.$emit('onValidClick', this.dataValue)
          }
      }
  }
</script>